import { missingWidget } from '../utils/helpers';

export default function themeBackground() {
  const widgetName = 'themeBackground';
  const $widget = $(`#${widgetName}`);
  const widgetOpts = typeof themeBackgroundOpts === 'undefined' ? null : themeBackgroundOpts;

  if (!widgetOpts) {
    missingWidget(widgetName);
    return;
  }

  const mainFeatureElement = 'body';

  return saffire.widgets.cardWidget($widget, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,

    cardWidgetLoaded: function (data, _owl, hasData) {
      $(`${mainFeatureElement}`).prepend('<div class="managed-bg"></div>');
      if (hasData) {
        addMainFeatureBackground(data.items[0], mainFeatureElement);
      }
      $widget.remove();
      $(`${mainFeatureElement} .managed-bg`).addClass('show-bg');
    },
  });
}

function addMainFeatureBackground(widgetData, featureTarget) {
  const { ImageWithPath } = widgetData;

  $(`${featureTarget} .managed-bg`).css({
    background: `url('${ImageWithPath}') no-repeat center/cover fixed`,
  });
}
